import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DialogConfirmPromptData } from './dialog-confirm-prompt-data';

@Component({
  selector: 'app-dialog-confirm-prompt',
  standalone: false,
  templateUrl: './dialog-confirm-prompt.component.html',
})
export class DialogConfirmPromptComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmPromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmPromptData,
  ) {}

  protected selectPrimary() {
    this.dialogRef.close(this.data);
    if ('function' === typeof this.data.confirmOnClick) {
      this.data.confirmOnClick();
    }
  }

  protected selectSecondary() {
    this.dialogRef.close(this.data);
    if ('function' === typeof this.data.secondary?.onClick) {
      this.data.secondary.onClick();
    }
  }
}
